import { Observable, Subject } from 'rxjs';

import { SnSmartBadgeService } from '@lib/ui/badge';

export class SnSentryTracking {
  private readonly _sentryCountChanged$ = new Subject<any>();

  private _sentryCount = 0;

  constructor(private readonly _smartBadge: SnSmartBadgeService) {}

  public addSentry(): void {
    this._sentryCount = this._sentryCount + 1;
    this.setSentryCount(this._sentryCount);
  }

  public removedSentry(): void {
    this._sentryCount--;
    this.setSentryCount(this._sentryCount);
  }

  public setSentryCount(count: number): void {
    this._sentryCount = count;
    this._smartBadge.setBadge('live-tracking__sentry-count', this._sentryCount);
    this._sentryCountChanged$.next();
  }

  public getSentryCount(): number {
    return this._sentryCount;
  }

  get sentryCountChanged(): Observable<any> {
    return this._sentryCountChanged$.asObservable();
  }
}
